import img1 from "../assets/logo.png";
import img2 from "../assets/florest/star-6.png";
import img3 from "../assets/florest/star-7.png";
import img4 from "../assets/florest/star-8.png";
import img5 from "../assets/florest/star-9.png";
import img6 from "../assets/florest/star-11.png";
import img7 from "../assets/florest/star-12.png";
import img8 from "../assets/ground/florest/floor.png";

const imageSrcs = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
];

export default imageSrcs;
